/* eslint-disable @typescript-eslint/no-unused-vars */
import { Delete, Edit } from '@mui/icons-material';
import { IconButton, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Days, DaysMapper, toHour } from '../../../../../../utils/time';

export interface ScheduleRuleProp {
  uuid: string;
  day: Days;
  startAt: number;
  duration: number;
}

interface ScheduleRulesProps {
  rules: ScheduleRuleProp[];
  onClickRemoveRule: (value: string) => void;
}

const useStyles = makeStyles(({ spacing, palette }: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: spacing(2),
  },

  item: {
    display: 'flex',
    color: palette.neutral[100],
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));

export const ScheduleRules = ({ rules, onClickRemoveRule }: ScheduleRulesProps): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      {rules.map((rule) => (
        <div key={`rule-${rule.day}-${rule.uuid}`} className={styles.item}>
          <div>{DaysMapper[rule.day]}</div>
          <div>
            das {toHour(rule.startAt)} ás {toHour(rule.startAt + rule.duration)}{' '}
          </div>
          <div>
            <IconButton onClick={() => onClickRemoveRule(rule.uuid)}>
              <Delete />
            </IconButton>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ScheduleRules;
